import { render, staticRenderFns } from "./ManageContact.vue?vue&type=template&id=5e860889&"
import script from "./ManageContact.vue?vue&type=script&lang=js&"
export * from "./ManageContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports